import { __decorate, __metadata, __param } from "tslib";
import { fetchFamiliesAttributes } from '@gn-audio/core/api/product-catalogue/fetch-families-attributes';
import { fetchGroupsAttributes } from '@gn-audio/core/api/product-catalogue/fetch-groups-attributes';
import { Component, Inject, Input } from 'angular-ts-decorators';
import { isProductSoftware } from 'src/Shared/utils/is-product-software';
import { convertToApplicableProduct } from '../utils/convert-to-applicable-product';
import { getUniqueFamilyIds } from '../utils/get-unique-family-ids';
import { sortByProductName } from '../utils/sort-by-product-name';
import template from './applicable-products.component.html';
var ApplicableProductsComponent = (function () {
    function ApplicableProductsComponent($q) {
        this.$q = $q;
        this.productIds = [];
        this.loaded = false;
        this.loading = false;
        this.products = [];
        this.collapsed = true;
        this.stopLoading = this.stopLoading.bind(this);
    }
    ApplicableProductsComponent.prototype.toggle = function () {
        var _this = this;
        if (!this.hasProducts) {
            return;
        }
        this.collapsed = !this.collapsed;
        if (this.loading || this.loaded) {
            return;
        }
        this.loading = true;
        this.$q.when(fetchGroupsAttributes(this.productIds, "supported"))
            .then(function (products) {
            var familyIds = getUniqueFamilyIds(products || []);
            if (familyIds.length === 0) {
                _this.stopLoading();
                return;
            }
            _this.$q.when(fetchFamiliesAttributes(familyIds, "supported"))
                .then(function (groupDictionary) {
                var groupedFamilyIds = Object.keys(groupDictionary);
                var productIds = _this.productIds.slice();
                groupedFamilyIds.forEach(function (x) {
                    var familyGroups = groupDictionary[x]
                        .filter(function (p) { return !isProductSoftware(p); });
                    var familyGroupsIds = familyGroups.map(function (p) { return p.groupId; });
                    if (familyGroupsIds.length > 0 && familyGroupsIds.every(function (g) { return productIds.indexOf(g) > -1; })) {
                        var applicableProduct = convertToApplicableProduct(familyGroups);
                        familyGroupsIds.forEach(function (g) { productIds.splice(productIds.indexOf(g), 1); });
                        _this.products.push(applicableProduct);
                    }
                });
                _this.products = sortByProductName(_this.products);
                if (productIds.length > 0) {
                    var groups = sortByProductName(products.filter(function (g) { return productIds.indexOf(g.groupId) > -1; }));
                    groups.filter(function (g) { return !isProductSoftware(g); })
                        .forEach(function (g) { _this.products.push(convertToApplicableProduct([g])); });
                }
            })
                .finally(_this.stopLoading);
        }, this.stopLoading);
    };
    Object.defineProperty(ApplicableProductsComponent.prototype, "hasProducts", {
        get: function () {
            return Array.isArray(this.productIds) && this.productIds.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    ApplicableProductsComponent.prototype.stopLoading = function () {
        this.loading = false;
        this.loaded = true;
    };
    ApplicableProductsComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], ApplicableProductsComponent.prototype, "productIds", void 0);
    ApplicableProductsComponent = __decorate([
        Component({
            selector: 'applicableProducts',
            template: template,
        }),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], ApplicableProductsComponent);
    return ApplicableProductsComponent;
}());
export { ApplicableProductsComponent };
